var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlur2 = function SvgBlur2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1313 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.794 768c163.088 0 305.568-88.227 382.317-219.556l.183.556s.249-.749.762-2.181a440.362 440.362 0 0 0 33.192-71.389C901.996 397.81 989.306 277.09 1144.29 206l-.92-.693C1230.34 171.296 1295.63 94.049 1312.83 0H1.294v295.514c-.663 9.909-1 19.908-1 29.986 0 244.386 198.114 442.5 442.5 442.5z",
    fill: "currentColor"
  })));
};

export { SvgBlur2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMxMyA3NjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ0Mi43OTQgNzY4YzE2My4wODggMCAzMDUuNTY4LTg4LjIyNyAzODIuMzE3LTIxOS41NTZsLjE4My41NTZzLjI0OS0uNzQ5Ljc2Mi0yLjE4MWE0NDAuMzYyIDQ0MC4zNjIgMCAwMDMzLjE5Mi03MS4zODlDOTAxLjk5NiAzOTcuODEgOTg5LjMwNiAyNzcuMDkgMTE0NC4yOSAyMDZsLS45Mi0uNjkzQzEyMzAuMzQgMTcxLjI5NiAxMjk1LjYzIDk0LjA0OSAxMzEyLjgzIDBIMS4yOTR2Mjk1LjUxNGMtLjY2MyA5LjkwOS0xIDE5LjkwOC0xIDI5Ljk4NiAwIDI0NC4zODYgMTk4LjExNCA0NDIuNSA0NDIuNSA0NDIuNXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";